import { jsx as _jsx } from "react/jsx-runtime";
import cn from "../../../utils/cn";
import Menu from "../../Menu";
import { Presets } from "../types";
const getPreset = (selectedPreset) => {
    const today = new Date();
    const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
    const last7Days = new Date(new Date().setDate(new Date().getDate() - 6));
    const last30Days = new Date(new Date().setDate(new Date().getDate() - 29));
    const thisMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const lastMonthStart = new Date(new Date().setMonth(new Date().getMonth() - 1, 1));
    const lastMonthEnd = new Date(new Date().setMonth(new Date().getMonth(), 0));
    return {
        [Presets.TODAY]: [today, today],
        [Presets.YESTERDAY]: [yesterday, yesterday],
        [Presets.LAST_7_DAYS]: [last7Days, today],
        [Presets.LAST_30_DAYS]: [last30Days, today],
        [Presets.THIS_MONTH]: [thisMonth, today],
        [Presets.LAST_MONTH]: [lastMonthStart, lastMonthEnd],
    }[selectedPreset];
};
const DatePickerPresets = ({ preset, presets, onChangePreset, onChange }) => {
    const presetsArray = presets || Object.values(Presets);
    const handlePreset = (selectedPreset) => {
        onChangePreset(selectedPreset);
        onChange(getPreset(selectedPreset));
    };
    return (_jsx(Menu, { className: "-ml-2.5 flex h-full w-32 flex-col border-gray-light border-r p-0", children: presetsArray.map((presetItem) => (_jsx(Menu.Item, { onClick: () => handlePreset(presetItem), className: cn([
                "rounded-none border-primary px-2.5",
                preset === presetItem && "border-primary border-r-2 bg-primary-2 font-bold text-primary hover:border-r-primary hover:bg-primary-2",
            ]), children: presetItem }, presetItem))) }));
};
export default DatePickerPresets;
